import { Box } from '@mui/system';
import { Tooltip, styled, useTheme } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import ColorModeContext from '../../../context/ColorModeContext';
import { Moon, Sun1 } from 'iconsax-react';
import { getCookie } from '../../../utils/cookies';
import { useTranslation } from 'react-i18next';

const BoxIcon = styled(Box)(({ theme }) => ({
  width: theme.spacing(10),
  height: theme.spacing(10),
  borderRadius: '100%',
  transition: 'all .1s linear',
  '&:hover': {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? theme.palette.primary.primary_40
        : theme.palette.primary.primary_99,
  },
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(10),
    height: theme.spacing(10),
  },
}));
const ThemeModeButton = () => {
  const colorMode = useContext(ColorModeContext);
  const [darkMode, setDarkMode] = useState('dark');
  const { t } = useTranslation();
  const theme = useTheme();

  const changeColorMode = (mode) => {
    setDarkMode((prev) => {
      return prev === 'dark' ? 'light' : 'dark';
    });
    colorMode.toggleDarkMode();
  };
  useEffect(() => {
    let mode = getCookie('darkMode');
    setDarkMode(mode === 'dark' ? 'light' : 'dark');
  }, []);
  return (
    <Tooltip title={t('global.dark_light')} placement="bottom">
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {darkMode !== 'light' ? (
          <BoxIcon onClick={() => changeColorMode()}>
            <Moon size={theme.spacing(4.75)} />
          </BoxIcon>
        ) : null}
        {darkMode !== 'dark' ? (
          <BoxIcon onClick={() => changeColorMode()}>
            <Sun1 size={theme.spacing(4.75)} />
          </BoxIcon>
        ) : null}
      </Box>
    </Tooltip>
  );
};
export default ThemeModeButton;
